import Swiper from 'swiper'

const swiperTechnologyDevelopment = new Swiper('.technology-development__swiper', {
  loop: true,
  slidesPerView: 1.2,

  breakpoints: {
    1400: {
      slidesPerView: 3,
    },
    960: {
      slidesPerView: 2,
    },
    700: {
      slidesPerView: 1.4,
    },
  },

  spaceBetween: 20,
})
